// extracted by mini-css-extract-plugin
export var gridContainer = "multiMediaImageGrid-module--gridContainer--1abe7";
export var gridItem = "multiMediaImageGrid-module--gridItem--90a8a";
export var multiMediaImageGrid = "multiMediaImageGrid-module--multiMediaImageGrid--e5e04";
export var textBlockHeadline = "multiMediaImageGrid-module--textBlockHeadline--7fba5";
export var textBlockParagraph = "multiMediaImageGrid-module--textBlockParagraph--d927b";